module.exports = __webpack_public_path__ + "static/media/bgtop-business-2.483d69a5.jpg";